import { getPreviewState } from './getPreviewState';
const ALLOWED_DFC_ERROR_FIELD_NAMES = new Set(['com_hubspot_portals_platform_app_rpc_AccessRpc_loginVerify', 'com_hubspot_portals_platform_app_rpc_NavigationRpc_getPortalNavigation']);

// brandData fetches are expected to fail while the portal is being previewed
// in the Theme Editor, so only suppress that error during preview sessions.
const PREVIEW_ONLY_ALLOWED_DFC_ERROR_FIELD_NAMES = new Set(['brandData']);
export const isAllowedDfcError = (_reason, fieldName) => {
  if (ALLOWED_DFC_ERROR_FIELD_NAMES.has(fieldName)) {
    return true;
  }
  if (PREVIEW_ONLY_ALLOWED_DFC_ERROR_FIELD_NAMES.has(fieldName)) {
    return getPreviewState().isPreview;
  }
  return false;
};